import { loadStageConfig } from './stageConfig.js';

const modules = import.meta.glob('../../../graphql/GMG_*_Config.json', {
    eager: true,
    import: 'default',
});

const pathMap = {
    Dev: '../../../graphql/GMG_Dev_Config.json',
    Test: '../../../graphql/GMG_Test_Config.json',
    Prod: '../../../graphql/GMG_Prod_Config.json',
};

const local = {
    url: 'https://rcapi.gmg-dev.aws.gmgcolor.com/graphql',
    region: 'eu-central-1',
};

const config = loadStageConfig(modules, pathMap, 'appSync', local, 'AppSync');

export default config;
